export default __webpack_public_path__ + "static/media/plus-subscription.f87a475f.svg";